import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS, STORAGE_TYPES } from 'common/constants/constants';
import { useContext } from 'react';

const MAX_SIZE = 5;

const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPES.LOCAL];

const useRecentFilterSetsHandler = Context => {
  const {
    state: { filterSets }
  } = useContext(Context);

  const recentFilterIdsFromStorage =
    JSON.parse(storageAccessor.get(LOCAL_STORAGE_KEYS.RECENT_FILTER_SET_IDS)) ||
    [];

  const recentFilterSets = recentFilterIdsFromStorage
    .map(filterSetId => filterSets?.[filterSetId])
    .filter(Boolean);

  const updateRecentFilterSetIds = filterSetId => {
    if (!filterSetId) return;

    const updatedFilterSetIds = [
      ...new Set([filterSetId, ...recentFilterIdsFromStorage])
    ].slice(0, MAX_SIZE);

    storageAccessor.set(
      LOCAL_STORAGE_KEYS.RECENT_FILTER_SET_IDS,
      JSON.stringify(updatedFilterSetIds)
    );
  };

  return {
    recentFilterSets,
    updateRecentFilterSetIds
  };
};

export default useRecentFilterSetsHandler;
